import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5bd7ce4c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5bd7ce4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd7ce4c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderBoxStatus: require('/drone/src/components/OrderBox/OrderBoxStatus.vue').default,TimeCountdown: require('/drone/src/components/TimeCountdown/index.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,OrderBoxKan: require('/drone/src/components/OrderBox/OrderBoxKan.vue').default,TimeCountdown: require('/drone/src/components/TimeCountdown/index.vue').default,GeneralGoodsDetailTable: require('/drone/src/components/GeneralGoodsDetail/Table.vue').default,PZButton: require('/drone/src/components/PZButton/index.vue').default,OrderPayDialog: require('/drone/src/components/OrderPayDialog/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default})
